// extracted by mini-css-extract-plugin
module.exports = {"buyOrTradeTabs":"styles_buyOrTradeTabs__ll7d4","buyOrTradeCard":"styles_buyOrTradeCard__LjY05"};